import { UserState } from 'src/app/global/state/app.reducers';
import { BlState } from './bl.reducer';
import * as BlActions from './bl.actions';
import * as BlSelectors from './bl.selectors';

export interface State extends UserState {
    blState: BlState
}

export { BlActions, BlSelectors };